<template>
  <div>
    <div class="flex preference-description">
      <div class="box grow">
        <div class="mt-32 ml-28" style="display:flex; heigh: 50px;">
          <div class="mr-22">
            <img src="/static/images/slack.svg" alt="slack logo"/>
          </div>
          <div class="slack-header mt-10 bold">
            <div>How to add Webhooks(Slack Channels)</div>
            <div>
              Note:
              <span style="font-weight:normal;">
                Check out <a href="https://api.slack.com/" target="_blank">Slack API</a> for more details
              </span>
            </div>
          </div>
        </div>
        <div class="slack-setup-instr">
          1. Create a new <a href="https://api.slack.com/apps" target="_blank">Slack app</a> in your Slack workspace: <br />
          2. From the <b>Features</b> Page, select <b>Activate Incoming Webhooks</b><br />
          3. Click <b>Add New Webhooks to Workspace</b><br />
          4. Pick a <b>Slack Channel</b> and click <b>Authorize</b><br />
          5. Use your
          <a 
            href="https://slack.com/intl/en-in/help/articles/115005265063-Incoming-webhooks-for-Slack"
            target="_blank"
          >
            Incoming Webhook URL
          </a>
          to post a message to Slack<br />
        </div>

        <div class="webhook-input-container">
          <div class="mr-30">
            <span class="webhook-inputs-label webhook-name-label"> Name </span>
            <el-input placeholder="Webhook Name" class="webhook-name-box" v-model.trim="webhook.webhookName"></el-input>
          </div>
          <div class="mr-34">
            <span class="webhook-inputs-label webhook-url-label"> Url </span>
            <el-input placeholder="Webhook URL" class="webhook-url-box" v-model.trim="webhook.webhookUrl"></el-input>
          </div>
          <div>
            <el-button type="text" class="add-button" @click="saveSlackSettings">Add</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="preference-settings">
      <action-table-element
        ref="slackTable"
        v-if="slackSettingReqStatus === 'success'"
        :columns="visibleSlackColumns"
        :table-data="copySlackSettings"
        :actions="tableActions"
        @update-record-count="recordCountHandler"
      ></action-table-element>
    </div>
    <el-divider></el-divider>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { slackSettingMetaInfo } from '@/column-header/slack/slack-setting-meta'
import TableToolbar from '@/components/table/TableToolbar.vue'
import ActionTableElement from '@/components/table/ActionTableElement.vue'
import {
  SLACK_SETTING_REQUEST,
  SLACK_SETTING_SUCCESS,
  SLACK_SETTING_CREATE_REQUEST,
  SLACK_SETTING_DELETE_REQUEST
} from '@/store/modules/slack/slack-setting.type'

import { SLACK_NOTIFICATION_PREFERENCE_REQUEST } from '@/store/modules/user/slack-preference.type'

export default {
  name: 'SlackSetting',
  data() {
    return {
      copySlackSettings: {},
      webhook: {
        webhookName: '',
        webhookUrl: ''
      },
      slackColumns: slackSettingMetaInfo.meta.columns,
      visibleSlackColumns: slackSettingMetaInfo.meta.columns,
      tableActions: [
        {
          name: 'Delete',
          showActionName: true,
          icon: 'c-icon el-icon-delete-solid',
          tooltip: 'Delete webhook',
          rbac: {
            subject: 'users',
            operation: 'write'
          },
          actionHandler: selection => {
            let vm = this
            if (vm.activeSlackChannels.includes(selection.row.webhook_url)) {
              vm.$message({
                type: 'error',
                message: `${selection.row.webhook_name} is currently active, please deactivate the channel before delete.`
              })
            } else {
              let message = `Are you sure you want to delete webhook ${selection.row.webhook_name}?`
              vm.$confirm(message, 'Confirm Action', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                callback: function(action) {
                  if (action === 'confirm') {
                    vm.$store.dispatch(SLACK_SETTING_DELETE_REQUEST, selection.row.id).then(
                      resp => {
                        vm.copySlackSettings = _.cloneDeep(vm.slackSettings)
                        vm.$store.dispatch(SLACK_SETTING_SUCCESS).then(_ => {
                          vm.$refs['slackTable'].setData()
                          vm.$refs['slackTableToolbar'].setQueryCountText()
                        })
                        vm.$message({
                          type: 'success',
                          message: `Successfully deleted webhook ${selection.row.webhook_name}`
                        })
                      },
                      _ => {
                        vm.$message({
                          type: 'error',
                          message: `Error while deleting webhook ${selection.row.webhook_name}`
                        })
                      }
                    )
                  } else if (action === 'cancel') {
                    vm.$message({
                      type: 'info',
                      message: `Operation canceled`
                    })
                  }
                }
              })
            }
          }
        }
      ],
      activeSlackChannels: []
    }
  },
  methods: {
    getSlackSettings(tableMetaData) {
      this.$store.dispatch(SLACK_SETTING_REQUEST).then(
        resp => {
          this.copySlackSettings = _.cloneDeep(this.slackSettings)
          this.$store.dispatch(SLACK_SETTING_SUCCESS)
          this.setTableMetaData(tableMetaData)
        },
        error => {
          console.log(error)
        }
      )
    },
    saveSlackSettings() {
      let flag = true
      if (this.webhook.webhookUrl === '' || this.webhook.webhookName === '') {
        flag = false
      } else {
        for (const entry of this.copySlackSettings.models) {
          if (
            this.webhook.webhookName === entry.webhook_name ||
            this.webhook.webhookUrl === entry.webhook_url
            ) {
            flag = false
            break
          }
        }
      }

      if(!flag){
        this.$message({
          type: 'error',
          message: 'Error while adding webhook'
        })
      }
      else {
        this.$store.dispatch(SLACK_SETTING_CREATE_REQUEST, this.webhook).then(
          data => {
            this.resetSlackSettings()
            this.copySlackSettings = _.cloneDeep(this.slackSettings)
            this.$store.dispatch(SLACK_SETTING_SUCCESS).then(_ => {
              this.$refs['slackTable'].setData()
              this.$refs['slackTableToolbar'].setQueryCountText()
            })
            this.$message({
              type: 'success',
              message: 'webhook successfully added'
            })
          },
          _ => {
            this.resetSlackSettings()
            this.$message({
              type: 'error',
              message: 'Error while adding webhook'
            })
          }
        )
      }
    },
    resetSlackSettings() {
      this.webhook.webhookName = ''
      this.webhook.webhookUrl = ''
    },
    updateTableQueryData() {
      if (this.$refs.slackTable) {
        this.$refs.slackTable.updateTableData()
      }
    },
    refreshTableData(tableMetaData) {
      if (!_.isUndefined(tableMetaData)) {
        tableMetaData = {
          activePage: 1,
          searchTags: []
        }
      }
      this.callApi(tableMetaData)
    },
    callApi(tableMetaData) {
      this.getSlackSettings(tableMetaData)
    },
    setTableMetaData(tableMetaData) {
      this.copySlackSettings.searchTags = tableMetaData.searchTags
      this.copySlackSettings.currentPage = tableMetaData.activePage
    },
    modifyColumnsData(selectedColumns) {
      this.visibleSlackColumns = this.copySlackSettings.updateVisibleColumns(this.slackColumns, selectedColumns)
    },
    recordCountHandler() {
      // key is used to re-render TableToolbar component
      // on page change to update 'queryCountText'
      this.copySlackSettings.key = !this.copySlackSettings.key
      this.copySlackSettings.reloadToolbar = false
    },
    fetchActiveSLackChannels() {
      this.$store.dispatch(SLACK_NOTIFICATION_PREFERENCE_REQUEST).then(
        preferences => {
          let slackPreference = _.cloneDeep(_.omit(this.userAccount.notificationSlackPreferences, 'user_acct'))
          slackPreference.slack_channels.forEach((channel, idx) => {
            this.activeSlackChannels.push(channel.channel_hook)
          })
        },
        error => {
          console.log(error)
        }
      )
    }
  },
  computed: {
    ...mapGetters(['slackSettingReqStatus', 'slackSettings', 'slackSettingDeleteReqStatus', 'userAccount'])
  },
  components: {
    TableToolbar,
    ActionTableElement
  },
  created() {
    let tableMetaData = {
      activePage: 1,
      searchTags: []
    }
    this.callApi(tableMetaData)
    this.fetchActiveSLackChannels()
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.preference-description {
  > .box:first-of-type {
    margin-right: 50px;
  }
}

.preference-settings {
  width: 65%;
  height: calc(100vh-60vh);
  margin-left: 81px;

  .title {
    min-width: 200px;
  }
}

.email {
  font-size: 6em;
}

.form-input {
  line-height: 40px;
}

>>> .el-select > .el-input {
  min-width: 250px;
}

.icon-text-button {
  background: var(--main-blue);
  padding: 5px 10px;

  span {
    .c-icon {
      color: white;
      font-size: 1.2em;
      vertical-align: text-bottom;
      margin-right: 5px;
    }
    span {
      color: white;
      margin-bottom: 6px;
    }
  }
}

.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0.5em 0px;
}

.footer {
  margin-top: 10px;
}

>>> .el-input__inner {
  border: 1px solid #A1A8AE;
  border-radius: 2px;
}

.slack-header {
  color: #292C32;
  height: 40px;
  width: 277px;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
}

.slack-setup-instr {
  margin: 27px 0px 32px 88px;
  height: 100px;
  width: 422px;
  color: #292C32;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
}

.webhook-name-box {
  box-sizing: border-box;
  height: 36px;
  width: 200px;
}

.webhook-url-box {
  box-sizing: border-box;
  height: 36px;
  width: 400px;
}
.add-button {
  color: #fff;
  border-radius: 4px;
  background-color: #1A90FA;
  height: 36px;
  width: 90px;
}

a {
  text-decoration: none;
  color:#1A90FA;
}

.webhook-input-container {
  display: flex;
  margin-left: 86px;
  margin-bottom: 37px;
}

.webhook-inputs-label {
  margin-right: 21px;
  height: 20px;
  color: #292C32;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
}

.webhook-name-label {
  width: 40px;
}

.webhook-url-label {
  width: 28px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/SlackSetting.vue